
import Transformer from './../transformer'
import SinisterTransformer from './sinister'
import AffectedTransformer from './affected'
import CampTransformer from './camp'

import moment from 'moment'
moment.locale('es-mx');
import { fullName } from '@/transformers/jbUser'

const fetchSinisterCollectionItem = function ({ are, revi, process, sinister_number,
  requisition_number, occurrence_date,
  assigment_date, highway,
  affected_id, folio_jb, id }) {
  return {
    id,
    folioJB: folio_jb,
    highway,
    sinisterNumber: sinister_number.sinister_number,
    urgent: sinister_number.its_urgent,
    priority: sinister_number.its_priority,
    affectedId: affected_id,
    affectedRequisitionNumber: requisition_number,
    sinisterDates: {
      dateOccurred: occurrence_date,
      dateAssignment: assigment_date,
    },
    dateOccurred: moment(occurrence_date),
    dateAssignment: moment(assigment_date),
    sinisterUserCostName: fullName(are),
    userReViName: fullName(revi),
    processId: process.id,
    processName: process.process,
  }
}

export default class SinisterRoadTransformer extends Transformer {

  static fetchCollection(roadSinisters) {
    return roadSinisters.map(fetchSinisterCollectionItem)
  }

  static fetch(roadSinister, customer) {
    const sinister = roadSinister.sinister
    const affected = roadSinister.affected || sinister.affected
    const highway = roadSinister.highway
    const highwaySection = roadSinister.highway_section
    const roadSinisterType = roadSinister.sinister_road_type
    const roadSinisterTypeDUA = roadSinister.sinister_dua_type
    const tollbooth = roadSinister.toll_booth
    const tollboothAttendant = roadSinister.toll_booth_attendant
    const camp = roadSinister.camp || null

    if (customer) {
      return {
        id: roadSinister.id,
        body: roadSinister.body,
        hasSignature: roadSinister.has_signature,
        urgent: sinister.its_urgent,
        priority: sinister.its_priority,
        highway,
        highwayId: highway.id,
        highwayName: highway.name,
        highwaySection,
        highwaySectionId: highwaySection.id,
        highwaySectionName: highwaySection.name,
        highwaySectionAttendantName: fullName(roadSinister.highway_section_attendant),
        userAdminChief: roadSinister.administrative_chief ? roadSinister.administrative_chief.id : null,
        adminChiefName: roadSinister.administrative_chief ? fullName(roadSinister.administrative_chief) : null,
        kilometer: roadSinister.kilometer,
        meter: roadSinister.meter,
        reportNumberInbursaOne: roadSinister.report_number_inbursa_one,
        reportNumberInbursaTwo: roadSinister.report_number_inbursa_two,
        sinister: SinisterTransformer.fetch(sinister, customer),
        sinisterSinisterNumber: sinister.sinister_number,
        affected: AffectedTransformer.fetch(affected),
        sinisterDates: {
          dateOccurred: moment(sinister.date_occurred),
          dateAssignment: moment(sinister.date_assignment),
        },
        affectedRequisitionNumber: affected.requisition_number,
        roadSinisterType,
        roadSinisterTypeId: roadSinisterType.id,
        roadSinisterTypeName: roadSinisterType.name,
        tollbooth,
        tollboothId: tollbooth.id,
        tollboothName: tollbooth.name,
        tollboothAttendantName: tollboothAttendant.name,
        userReVi: roadSinister.user_revi.id,
        userReViName: fullName(roadSinister.user_revi.user),
        camp: camp ? CampTransformer.fetch(camp) : camp,
        campId: camp.id,
        pendingPriceAuthorization: affected.pending_price_authorization,
      }
    }
    return {
      id: roadSinister.id,
      body: roadSinister.body,
      hasSignature: roadSinister.has_signature,
      urgent: sinister.its_urgent,
      priority: sinister.its_priority,
      highway,
      highwayId: highway.id,
      highwayName: highway.name,
      highwaySection,
      highwaySectionId: highwaySection.id,
      highwaySectionName: highwaySection.name,
      highwaySectionAttendant: roadSinister.highway_section_attendant.id,
      highwaySectionAttendantName: fullName(roadSinister.highway_section_attendant),
      userAdminChief: roadSinister.administrative_chief ? roadSinister.administrative_chief.id : null,
      adminChiefName: roadSinister.administrative_chief ? fullName(roadSinister.administrative_chief) : null,
      kilometer: roadSinister.kilometer,
      meter: roadSinister.meter,
      reportNumberInbursaOne: roadSinister.report_number_inbursa_one,
      reportNumberInbursaTwo: roadSinister.report_number_inbursa_two,
      sinister: SinisterTransformer.fetch(sinister),
      sinisterUserCostName: sinister.users_costs.user.first_name,
      sinisterSinisterNumber: sinister.sinister_number,
      affected: AffectedTransformer.fetch(affected),
      sinisterDates: {
        dateOccurred: sinister.date_occurred,
        dateAssignment: sinister.date_assignment,
      },
      affectedRequisitionNumber: affected.requisition_number,
      roadSinisterType,
      roadSinisterTypeId: roadSinisterType.id,
      roadSinisterTypeName: roadSinisterType.name,
      roadSinisterTypeDUA,
      tollbooth,
      tollboothId: tollbooth.id,
      tollboothName: tollbooth.name,
      tollboothAttendant,
      tollboothAttendantId: tollboothAttendant.id,
      tollboothAttendantName: tollboothAttendant.name,
      userReVi: roadSinister.user_revi.id,
      userReViName: fullName(roadSinister.user_revi.user),
      camp: camp ? CampTransformer.fetch(camp) : camp,
      campId: camp.id,
      pendingPriceAuthorization: affected.pending_price_authorization,
      warehouse: {
        name: roadSinister.warehouse.name,
        id: roadSinister.warehouse.id
      }
    }
  }
  static send(roadSinister) {
    const affected = roadSinister.affected
    const sinister = roadSinister.sinister
    let binnacleComment = roadSinister.binnacleComment
    // DataSection
    const data = new FormData()
    let insurance_carrier = sinister.insuranceCarrierId
    if (insurance_carrier === 0) {
      insurance_carrier = null
    }
    if (binnacleComment == "") { binnacleComment = null }
    return {
      id: roadSinister.id,
      body: roadSinister.body,
      has_signature: roadSinister.hasSignature,
      highway: roadSinister.highwayId,
      highway_section: roadSinister.highwaySectionId,
      highway_section_attendant: roadSinister.highwaySectionAttendantId,
      administrative_chief: roadSinister.userAdminChief,
      kilometer: roadSinister.kilometer,
      meter: roadSinister.meter,
      report_number_inbursa_one: roadSinister.reportNumberInbursaOne,
      report_number_inbursa_two: roadSinister.reportNumberInbursaTwo,
      sinister: {
        customer: sinister.customerId,
        insurance_carrier,
        date_assignment: sinister.dateAssignment,
        date_occurred: sinister.dateOccurred,
        sinister_number: sinister.sinisterNumber,
        type_of_job: sinister.typeOfJobId,
        users_costs: sinister.userCost,
      },
      affected: AffectedTransformer.send(affected),
      sinister_road_type: roadSinister.roadSinisterTypeId,
      sinister_dua_type: roadSinister.roadSinisterTypeDUA,
      toll_booth: roadSinister.tollboothId,
      toll_booth_attendant: roadSinister.tollboothAttendantId,
      user_revi: roadSinister.userReVi,
      binnacle_comment: binnacleComment,
      its_urgent: roadSinister.urgent,
      its_priority: roadSinister.priority
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/sinister/road.js